import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { Container, Header, Label, Divider, Segment } from 'semantic-ui-react'
import { CommentCount } from 'disqus-react'

const BlogPage = ({
  data: {
    allMarkdownRemark: { edges },
  },
}) => {
  const Posts = edges
    .filter(edge => !!edge.node.frontmatter.date)
    .map(({ node: { frontmatter: post } }) => {
      return (
        <Segment key={post.id} stacked textAlign='center' padded='very'>
          <Header as='h2' content={<Link to={post.path}>{post.title}</Link>} />
          <Label icon='time' size='tiny' basic content={post.date} />
          <Label
            icon='comment'
            size='tiny'
            basic
            content={
              <CommentCount
                shortname='fake-flight-tickets'
                config={{
                  url: `https://www.fakeflighttickets.com${post.path}`,
                  identifier: post.id,
                  title: post.title,
                }}
              />
            }
          />
        </Segment>
      )
    })

  return (
    <Container text>
      <Helmet>
        <title>Blog - Fake Flight Tickets</title>
        <meta name='twitter:title' content='Blog - Fake Flight Tickets' />
      </Helmet>
      <Header as='h1' content='Blog' />
      {Posts}
    </Container>
  )
}

export default BlogPage

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/blog.js